import React, { ReactElement } from 'react';
import { Fab } from '@mui/material';
import GVTooltip from 'components/lib/GVToolTip/GVTooltip';

interface GVActionButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  label: string | ReactElement;
  disabled?: boolean;
  tooltipTitle?: string;
}

const GVActionButton = (props: GVActionButtonProps) => {
  const tooltipTitle = props.tooltipTitle ?? '';
  return (
    <GVTooltip title={tooltipTitle} disableHoverListener={!props.disabled}>
      <Fab
        id="actionButton"
        data-testid="action-button"
        variant="extended"
        color="primary"
        onClick={props.onClick}
        disabled={props.disabled}
      >
        {props.label}
      </Fab>
    </GVTooltip>
  );
};

export default GVActionButton;
